<template>
  <div class="space-y-4 p-4">
    <div class="w-full space-y-2">
      <form @submit.prevent="buscarComprobante">
        <div class="flex flex-col items-center gap-x-6 gap-y-2 sm:flex-row">
          <label for="nro-comprobante" class="whitespace-nowrap text-base font-medium text-gray-700"
            >Nro. comprobante
          </label>
          <input
            id="nro-comprobante"
            v-input-filter="value => /^\d*$/.test(value)"
            class="w-72 appearance-none rounded-md border border-gray-400 p-2 text-gray-900 placeholder-gray-700 transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm"
            v-model="numeroComprobante"
          />
          <button
            class="w-fit space-x-2 whitespace-nowrap rounded-md border px-3 py-2 text-sm font-medium"
            :class="{
              'border-blue-brand-700 bg-blue-brand-500 text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700':
                numeroComprobante,
              'border-gray-300 bg-gray-100 text-gray-400': !numeroComprobante,
            }"
            :disabled="!numeroComprobante"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
    </div>
    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-200"
      enter-class="opacity-0"
      leave-to-class="opacity-0"
      mode="out-in"
    >
      <Cargando v-if="isLoading" key="1" />
      <Empty v-else-if="error" key="2" />
      <div v-else-if="comprobanteTerceros" key="3" class="space-y-4">
        <div class="space-y-2">
          <div class="text-lg font-semibold text-gray-900">Datos del comprobante</div>
          <div class="flex flex-wrap gap-y-1 tracking-wide text-gray-700">
            <div class="space-x-2 after:px-2 after:font-thin after:content-['\2022']">
              <span class="font-semibold">Nro. comprobante</span>
              <span>{{ comprobanteTerceros.comprobante.numero_comprobante }}</span>
            </div>
            <div class="space-x-2 after:px-2 after:font-thin after:content-['\2022']">
              <span class="font-semibold">Monto</span>
              <span>{{ comprobanteTerceros.comprobante.monto | currency }}</span>
            </div>
            <div
              v-if="factura"
              class="space-x-2 after:px-2 after:font-thin after:content-['\2022']"
            >
              <span class="font-semibold">Factura de América asociada</span>
              <span class="whitespace-nowrap">{{ factura }}</span>
            </div>
            <div class="space-x-2">
              <span class="font-semibold">Delegación</span>
              <span class="whitespace-nowrap">{{ comprobanteTerceros.sede.descripcion }}</span>
            </div>
          </div>
          <div class="flex flex-wrap gap-x-10 gap-y-4">
            <div class="min-w-1/4 max-w-full gap-2 sm:max-w-[45%]">
              <div class="text-lg font-semibold text-gray-900">Datos del pago</div>
              <div class="space-x-2">
                <span class="font-semibold">Estado</span>
                <span class="uppercase">{{
                  textoEstadoPago(comprobanteTerceros.pago.estado_id)
                }}</span>
              </div>
              <div class="" v-if="comprobanteTerceros.pago">
                <span class="font-semibold">Observaciones</span>
                <p v-if="comprobanteTerceros.pago.observaciones">
                  {{ comprobanteTerceros.pago.observaciones }}
                </p>
                <p v-else>&ndash;</p>
              </div>
            </div>
            <div class="min-w-1/4 max-w-full gap-2 sm:max-w-[45%]">
              <div class="text-lg font-semibold text-gray-900">Datos del uso</div>
              <div class="space-x-2">
                <span class="font-semibold">Estado</span>
                <span class="uppercase">{{
                  textoEstadoUso(comprobanteTerceros.uso.estado_id)
                }}</span>
              </div>
              <div class="" v-if="comprobanteTerceros.uso">
                <span class="font-semibold">Observaciones</span>
                <p v-if="comprobanteTerceros.uso.observaciones">
                  {{ comprobanteTerceros.uso.observaciones }}
                </p>
                <p v-else>&ndash;</p>
              </div>
            </div>
          </div>
        </div>
        <ComprobantesFactura
          v-if="comprobanteUsado"
          :facturaCodigo="comprobanteTerceros.uso.factura_codigo"
          :facturaNumero="comprobanteTerceros.uso.factura_numero"
          :sede="comprobanteTerceros.sede"
        />
        <MessageCard v-if="!comprobantePago" type="warning" :message="mensajeComprobanteImpago" />
        <MessageCard
          v-else-if="comprobanteUsado"
          type="warning"
          message="No es posible marcar como devuelto un comprobante asociado a una factura."
        />
        <div v-else class="space-y-4 py-2">
          <div class="space-y-2 md:flex md:items-center md:space-x-6 md:space-y-0">
            <label for="observaciones" class="w-44 text-sm font-medium tracking-wide text-gray-700">
              <span>Observaciones</span>
            </label>
            <div class="w-full max-w-xl sm:w-5/6">
              <textarea
                v-model="observaciones"
                id="observaciones"
                maxlength="255"
                class="block w-full rounded-md shadow-sm transition duration-200 ease-in-out sm:text-sm"
              />
            </div>
          </div>
          <div class="flex justify-center">
            <button
              class="inline-flex items-center space-x-2 rounded-md bg-colescba-blue-500 px-2 py-2 text-sm font-medium uppercase text-white transition duration-150 ease-in-out hover:bg-colescba-blue-600 focus:outline-none focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1"
              @click="showConfirmModal = true"
              type="button"
            >
              Marcar como devuelto
            </button>
          </div>
        </div>
      </div>
    </transition>
    <ConfirmationModal
      :isOpen="showConfirmModal"
      @save="devolucionComprobante"
      @modal:cancel="showConfirmModal = false"
    >
      <span v-if="comprobanteTerceros">
        El comprobante {{ comprobanteTerceros.comprobante.numero_comprobante }} será marcado como
        devuelto.
      </span>
    </ConfirmationModal>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import { mapState, mapActions } from 'vuex'

import Cargando from '@/components/Core/Cargando'
import Empty from '@/components/Core/Empty'
import MessageCard from '@/components/Core/MessageCard'
import ComprobantesFactura from '@/components/DevolucionComprobantes/ComprobantesFactura'
import ConfirmationModal from '@/components/Core/ConfirmationModal'

export default {
  components: { Cargando, Empty, MessageCard, ComprobantesFactura, ConfirmationModal },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      isLoading: false,
      error: null,
      numeroComprobante: null,
      comprobanteTerceros: null,
      observaciones: null,
      showConfirmModal: false,
    }
  },

  mounted() {
    this.fetchEstadosUso({ cuitCuil: this.user.cuitCuil.numero, portalPagos: this.portalPagos })
    this.fetchEstadosPago({ cuitCuil: this.user.cuitCuil.numero, portalPagos: this.portalPagos })
  },

  computed: {
    ...mapState({
      estadosUso: state => state.app.estadosUso,
      estadosPago: state => state.app.estadosPago,
    }),

    comprobantePago() {
      return this.comprobanteTerceros?.pago.estado_id == 'PAGO'
    },
    comprobanteDevuelto() {
      return this.comprobanteTerceros?.pago.estado_id == 'DEVUELTO'
    },
    comprobanteUsado() {
      return this.comprobanteTerceros?.uso.estado_id == 'USADO'
    },
    factura() {
      return this.comprobanteTerceros.uso.factura_codigo
        ? `${this.comprobanteTerceros.uso.factura_codigo.trim().toUpperCase()} ${
            this.comprobanteTerceros.uso.factura_numero
          }`
        : null
    },
    mensajeComprobanteImpago() {
      return this.comprobanteDevuelto
        ? 'El comprobante ya ha sido marcado como devuelto.'
        : 'No es posible marcar como devuelto este comprobante ya que no se encuentra pago.'
    },
  },

  methods: {
    ...mapActions({
      fetchEstadosUso: 'app/fetchEstadosUso',
      fetchEstadosPago: 'app/fetchEstadosPago',
    }),
    async buscarComprobante() {
      this.isLoading = true
      this.error = null
      try {
        this.comprobanteTerceros = await this.portalPagos.getComprobanteTerceros(
          this.user.cuitCuil.numero,
          this.numeroComprobante
        )
      } catch (error) {
        this.error = true
      } finally {
        this.isLoading = false
      }
    },
    textoEstadoUso(estadoId) {
      return this.estadosUso?.find(e => e.id.trim() == estadoId).descripcion
    },
    textoEstadoPago(estadoId) {
      return this.estadosPago?.find(e => e.id.trim() == estadoId).descripcion
    },
    async devolucionComprobante(done) {
      try {
        await this.portalPagos.patchPagoPorComprobante(
          this.user.cuitCuil.numero,
          this.comprobanteTerceros.comprobante.numero_comprobante,
          {
            pago_id: 'DEVUELTO',
            forma_pago_id: this.comprobanteTerceros.forma_pago_id,
            observaciones: this.observaciones,
          }
        )

        done()

        this.$toast.open({
          message: 'Se marcó como devuelto el comprobante.',
          type: 'success',
          duration: 2500,
          dismissible: true,
        })

        this.showConfirmModal = false
        this.buscarComprobante()
      } catch (e) {
        console.log(e)
        done('Ocurrió un error al procesar la información.')
      }
    },
  },
}
</script>
